import { render } from "./RulesBooksView.vue?vue&type=template&id=af8d3658&scoped=true"
import script from "./RulesBooksView.vue?vue&type=script&lang=js"
export * from "./RulesBooksView.vue?vue&type=script&lang=js"

import "./RulesBooksView.vue?vue&type=style&index=0&id=af8d3658&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-af8d3658"]])

export default __exports__